
/* injects from baggage-loader */

export const words = [
	//
	{
		text: 'local',
		class: 'small',
	},
	{
		text: 'data',
		class: 'small',
	},
	{
		text: 'formal',
		class: 'small',
	},
	{
		text: 'introdução',
		class: 'big',
	},
	{
		text: 'conclusão',
		class: 'big',
	},
	{
		text: 'opinião',
		class: 'big',
	},
	{
		text: 'discrição',
		class: 'big',
	},
	{
		text: 'concluir',
		class: 'big',
	},
	{
		text: 'respeitosa',
		class: 'big',
	},
	{
		text: 'formal',
		class: 'big',
	},
	{
		text: 'informal',
		class: 'big',
	}	
//
]


// WEBPACK FOOTER //
// ./src/app/pages/page-nine/page-nine.const.js